"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 7.5A2.5 2.5 0 0 1 5.5 5h13A2.5 2.5 0 0 1 21 7.5v9a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 16.5zm2.84-.367a.5.5 0 0 0-.68.734l4.298 3.967-4.312 4.312a.5.5 0 0 0 .708.708l4.34-4.34.789.727a1.5 1.5 0 0 0 2.034 0l.79-.728 4.34 4.34a.5.5 0 0 0 .707-.707l-4.312-4.312 4.297-3.967a.5.5 0 0 0-.678-.734l-5.822 5.373a.5.5 0 0 1-.678 0z"
}), 'EmailFilled');
//# sourceMappingURL=index.js.map